import React, { useState } from 'react'
import './ContactProfileView.scoped.sass'

import ContactProfile from './ContactProfile/ContactProfile'
import { ContactList } from '@/components/SideMenu/components/ContactMenu/components/Contacts/ContactList/ContactList'
import commonsService from '@/services/commons.service'
import useRenderEvent from '@/core/hooks/useRenderEvent'

const ContactProfileView = () => {
  // eslint-disable-next-line
  const [showProfile, setShowProfile] = useState(!commonsService.isMobile())
  const [contact, setContact] = useState(undefined)

  useRenderEvent(['CONTACT_VIEW:UPDATED'], (contact) => {
    setContact(contact)
  })

  return (
    <div className='main-container'>
      { contact && showProfile && <ContactProfile contact={contact}/> }
      { !showProfile && commonsService.isMobile() && <ContactList/> }
    </div>
  )
}

export default ContactProfileView
